<template>
        <v-carousel 
          hide-delimiters
          height="500" 
          v-bind:class="{ [`elevation-${selected}`]: true }">
      <v-carousel-item
        v-for="(item,i) in items"
        :key="i"
        :src="item.src"
      ></v-carousel-item>
    </v-carousel>
</template>

<script>
export default {
        data: () => ({
            items: [
        {
          src: require('../assets/samajuri/samajuri (1).jpg')
        },
        {
          src: require('../assets/samajuri/samajuri (2).jpg')
        },
        {
          src: require('../assets/samajuri/samajuri (3).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (4).jpg')
        },
        {
          src: require('../assets/samajuri/samajuri (5).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (6).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (7).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (8).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (9).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (10).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (11).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (12).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (13).jpg')
        },
        {
          src: require('../assets/samajuri/samajuri (14).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (15).jpg')
        },
        {
          src: require('../assets/samajuri/samajuri (16).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (17).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (18).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (19).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (20).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (21).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (22).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (23).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (24).jpg')
        },
        {
          src: require('../assets/samajuri/samajuri (25).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (26).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (27).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (28).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (29).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (30).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (31).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (32).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (33).jpg')
        },
        {
          src: require('../assets/samajuri/samajuri (34).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (35).jpg')
        },
        {
          src: require('../assets/samajuri/samajuri (36).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (37).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (38).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (39).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (40).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (41).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (42).jpg')       
        },
        {
          src: require('../assets/samajuri/samajuri (43).jpg')       
        },

      ],
       selected: 24
        })
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/samajuri.vue